export default __webpack_public_path__ + "static/media/verifiedIcon.713e7bf5.svg";